<div class="rules-search-items-results search-dropdown">
    <!-- search dropdown discarded -->
    <!-- <div class="op_icon" (click)="open=!open; " title="Display options">
        <span></span>
    </div> -->
    <!-- TODO oct-2023 define how to make a different item list depending on key or option given. -->
    <ul class="rules-search-default-subsection" *ngIf=" availableItems != null && availableItems.length > 0 else nosearchresult">
        <li *ngFor="let item of availableItems" (click)="onSelect(item)" class="finder-item"
            [ngClass]="{'selectable-li': item.options.selectable}">
            <!-- options selectable true is an item with border  -->
            <span class="items-results-group" *ngIf="!item.options.selectable; else isoneitem"
                [ngStyle]="{'color': item.options.color}"> <em>{{item.description}}</em> </span>


            <!-- options selectable false is a CATEGORy header not selectable   -->

            <ng-template #isoneitem>
                <core-rule-results-item [item]="item" [selected]="isSelected(item.key)">
                </core-rule-results-item>
            </ng-template>

        </li>
    </ul>
    <ng-template #nosearchresult>
        <div class="rules-search-no-tags">There are no matches for your search.</div>
    </ng-template>
</div>